/**
 * RecipesTabPanel – Recipes screen layout: card + SavedListsManager.
 * No inner scroll: card grows with content; only main-content scrolls.
 * Matches app layout shell (--app-content-padding-x on tab-content-wrapper).
 * Content width capped at --tab-content-max-width to match Shopping list (Shop tab).
 */
import { useEffect } from 'react'
import SavedListsManager from '../SavedListsManager.jsx'
import { useGuestKitchen } from '../contexts/GuestKitchenContext.jsx'
import DismissibleOnboardingMessage from './DismissibleOnboardingMessage.jsx'
import LowPantryShoppingBanner from './LowPantryShoppingBanner.jsx'
import useOnboardingVisibility from '../hooks/useOnboardingVisibility.js'
import { ONBOARDING_BANNER_FLAGS, ONBOARDING_MESSAGES } from '../utils/onboardingRegistry.js'

export default function RecipesTabPanel({
  onLoadList,
  selectedStore = null,
  setShowLoginModal,
  onRecipeImageSelected,
  onFeaturedPromptSelect,
  showGoShoppingBanner = false,
  onGoShopping,
  onPantryShoppingBannerFromMatch,
  onViewRecipe,
  onManagePreferences,
  guestMode = false,
  hidePageHeader = false,
  hideGetRecipesNav = false,
  defaultGetRecipesMethod,
  footer = null,
}) {
  const { isVisible: isCookIntroVisible } = useOnboardingVisibility(ONBOARDING_MESSAGES.cookIntro.storageKey)
  const showCookIntro = !hidePageHeader && ONBOARDING_BANNER_FLAGS.cookIntro && isCookIntroVisible
  const { refreshSummary } = useGuestKitchen()

  useEffect(() => {
    if (guestMode) refreshSummary?.()
  }, [guestMode, refreshSummary])

  return (
    <div
      id="recipes-panel"
      className="tab-content recipes-tab"
      role="tabpanel"
      aria-labelledby="recipes-tab"
    >
      <div className="tab-content-wrapper">
      <div
        id="saved-lists-panel"
        className="card recipes-tab-card recipes-tab-card-full"
      >
        <div className="recipes-tab-content">
          <SavedListsManager
            onLoadList={onLoadList}
            selectedStore={selectedStore}
            setShowLoginModal={setShowLoginModal}
            onRecipeImageSelected={onRecipeImageSelected}
            onFeaturedPromptSelect={onFeaturedPromptSelect}
            onPantryShoppingBannerFromMatch={onPantryShoppingBannerFromMatch}
            onViewRecipe={onViewRecipe}
            onManagePreferences={onManagePreferences}
            guestMode={guestMode}
            hidePageHeader={hidePageHeader}
            hideGetRecipesNav={hideGetRecipesNav}
            defaultGetRecipesMethod={defaultGetRecipesMethod}
            pageNotices={
              <>
                <DismissibleOnboardingMessage
                  messageId="cookIntro"
                  className="onboarding-message-left"
                  isVisible={showCookIntro}
                />
                {showGoShoppingBanner && (
                  <LowPantryShoppingBanner onGoShopping={onGoShopping} />
                )}
              </>
            }
            pageNoticesActive={Boolean(showCookIntro || showGoShoppingBanner)}
          />
        </div>
      </div>
      {footer}
      </div>
    </div>
  )
}
